import backendUrl from "./backendUrl";

const fetchAPI = async (
  endpoint,
  options = {},
  isJSON = true,
  returnHeaders = null
) => {
  const authState = JSON.parse(localStorage.getItem("authState"));
  const url = `${backendUrl}/wp-json/wp/v2${endpoint}`;
  const headers = options.headers ? options.headers : {};

  // Set options
  options = {
    ...options,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...headers,
    },
  };

  // Set body and content type
  const { body = null } = options ? options : {};
  if (body) options.body = isJSON ? JSON.stringify(body) : body;
  if (!isJSON) delete options.headers["Content-Type"];

  // Set auth
  if (authState && authState.token)
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${authState.token}`,
    };

  // Send request
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    if (data.hasOwnProperty("error")) throw new Error(data.error);
    if (returnHeaders) {
      const responseHeaders = returnHeaders.map((header) =>
        response.headers.get(header)
      );
      return { data, headers: responseHeaders };
    }
    return data;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
};

export default fetchAPI;
